module.exports = __webpack_public_path__ + "img/shop12.817ca4ec.jpg";